export default __webpack_public_path__ + "static/media/not-found.c8301e2a.svg";